// src/services/ads.ts
import type { RoddoAdPlacement } from '../constants/adMob';

export type NativeFeedPostItem<T> = {
  kind: 'post';
  id: string;
  post: T;
};

export type NativeFeedAdItem = {
  kind: 'ad';
  id: string;
  placement: RoddoAdPlacement;
  afterPostIndex: number;
};

export type NativeFeedItem<T> = NativeFeedPostItem<T> | NativeFeedAdItem;

export function insertNativeFeedAdSlots<T extends { id?: string }>(
  posts: T[],
  options?: {
    enabled?: boolean;
    interval?: number;
    placement?: RoddoAdPlacement;
  },
): NativeFeedItem<T>[] {
  const enabled = Boolean(options?.enabled);
  const interval = Math.max(1, Math.floor(Number(options?.interval || 2)));
  const placement = options?.placement || 'baleen-bay-feed';

  const items: NativeFeedItem<T>[] = [];

  posts.forEach((post, index) => {
    const postId = String(post?.id || `post-${index}`);
    items.push({ kind: 'post', id: postId, post });

    const isLastPost = index >= posts.length - 1;
    const shouldInsertAd = enabled && !isLastPost && (index + 1) % interval === 0;

    if (shouldInsertAd) {
      items.push({
        kind: 'ad',
        id: `${placement}-slot-${index + 1}`,
        placement,
        afterPostIndex: index,
      });
    }
  });

  return items;
}
